// 防抖处理
const debounce = (fn, delay = 100) => {
  let timer = null;
  return function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, arguments), delay);
  };
};
export const useScreenAuto = () => {
  const appRef = ref();
  const designDraftWidth = 1920; // 设计稿的宽度
  const designDraftHeight = 1080; // 设计稿的高度
  // if (!appRef.value) {
  //   return {
  //     appRef,
  //   };
  // }
  const handleScreenAuto = () => {
    const clientWidth = document.documentElement.clientWidth;
    const clientHeight = document.documentElement.clientHeight;
    // 根据屏幕的变化适配的比例
    const scale = clientWidth / clientHeight < designDraftWidth / designDraftHeight ? clientWidth / designDraftWidth : clientHeight / designDraftHeight;

    // 计算缩放后元素的宽度和高度
    const scaledWidth = designDraftWidth * scale;
    const scaledHeight = designDraftHeight * scale;

    // 计算水平和垂直方向的偏移量
    const translateX = (clientWidth - scaledWidth) / 2;
    const translateY = (clientHeight - scaledHeight) / 2;
    console.log("scale", scale);

    // 应用缩放和偏移
    appRef.value.style.transformOrigin = "top left";
    appRef.value.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
  };
  // 初始化监听
  onMounted(() => {
    console.log('42');
    let root = document.documentElement;
    // 修改CSS变量的值
    root.style.setProperty("--design-width", designDraftWidth + "px");
    root.style.setProperty("--design-height", designDraftHeight + "px");
    handleScreenAuto();
    window.addEventListener("resize", debounce(handleScreenAuto));
  });

  // 清除监听
  onUnmounted(() => {
    window.removeEventListener("resize", debounce(handleScreenAuto));
  });
  return {
    appRef,
    handleScreenAuto
  };
};